import './plugins/prism';
import './plugins/vue-scrollto';
import Vue from 'vue';
import App from './App.vue';
import { createRouter } from '@/router';
import { createKitRouter } from '@/router/kit_router';
import VueMeta from 'vue-meta';
import Vuex from 'vuex';
import Router from 'vue-router';
import { createStore } from '@/store';
import VSelect from 'vue-select';
import gdprPlugin from '@/plugins/gdprPlugin';
import { currentInstance, getLocaleFromLanguageCode } from '@/heplers';
import { StoreMutations } from '@/templates/DataNames';
import LoggerPlugin from './plugins/logger';

Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.use(Vuex);
Vue.use(Router);
Vue.use(gdprPlugin);
Vue.use(LoggerPlugin);

// @ts-expect-error: Type 'VueSelectProps' is not assignable to type 'RecordPropsDefinition<DefaultProps>'. Index signature for type 'string' is missing in type 'VueSelectProps'
Vue.component('VueSelect', VSelect);

export const store = createStore();

// eslint-disable-next-line @typescript-eslint/no-empty-function
export async function createApp({ beforeApp = () => {}, afterApp = () => {} } = {}) {
  const router = currentInstance === 'vox' ? createRouter() : createKitRouter();

  //Adding locale query to URL with default language on kit-docs
  if (currentInstance != 'vox') {
    router.beforeEach((to, from, next) => {
      if (!to.query.locale) {
        const languageCode = from.query['locale'] ? from.query['locale'] : 'en';
        store.commit(StoreMutations.SET_CURRENT_LOCALE, getLocaleFromLanguageCode(languageCode));
        // next({path: to.path, query: {locale: languageCode}})
        next();
      } else {
        store.commit(
          StoreMutations.SET_CURRENT_LOCALE,
          getLocaleFromLanguageCode(to.query['locale'])
        );
        next();
      }
    });
  }

  // await sync(store, router)
  // @ts-expect-error: Expected 0 arguments, but got 1
  await beforeApp({ router, store });

  const app = new Vue({
    router,
    store,
    render: (h) => h(App),
  });

  const result = {
    app,
    router,
    store,
  };

  // @ts-expect-error: Expected 0 arguments, but got 1
  await afterApp(result);
  //if state does not setted, go back
  if (!result.store.state) {
    router.back();
    return;
  }
  return result;
}
